var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8628 5.25401L10.8628 6.73596L4.13596 6.73596C4.04846 6.73596 3.97688 6.80816 3.97688 6.89639L3.97688 8.0996C3.97688 8.18784 4.04846 8.26003 4.13596 8.26003L10.8628 8.26003L10.8628 9.74599C10.8628 9.88035 11.016 9.95455 11.1194 9.87233L13.939 7.62634C13.958 7.61133 13.9734 7.59216 13.9839 7.57027C13.9945 7.54838 14 7.52435 14 7.5C14 7.47565 13.9945 7.45162 13.9839 7.42973C13.9734 7.40784 13.958 7.38867 13.939 7.37366L11.1213 5.12767C11.016 5.04546 10.8628 5.11965 10.8628 5.25401ZM4.73249 14.8396L4.73249 13.6364C4.73249 13.5481 4.6609 13.4759 4.57341 13.4759L1.51121 13.4759L1.51122 1.52406L4.57341 1.52406C4.6609 1.52406 4.73249 1.45187 4.73249 1.36364L4.73249 0.160427C4.73249 0.0721921 4.6609 -4.08225e-07 4.57341 -4.12049e-07L0.636302 -5.84146e-07C0.284348 -5.9953e-07 9.41139e-07 0.286764 9.25624e-07 0.641711L3.26053e-07 14.3583C3.10538e-07 14.7132 0.284348 15 0.636301 15L4.57341 15C4.6609 15 4.73249 14.9278 4.73249 14.8396Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.cc65d44ce41f15b14bdea92fe3b54ae9.svg";
export { ForwardRef as ReactComponent };